/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["dx-box[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{opacity:.1}dx-box[_ngcontent-%COMP%]:hover   button[_ngcontent-%COMP%]{opacity:1}mat-icon[matSuffix][_ngcontent-%COMP%]{cursor:pointer}.ng-invalid[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-color:red}[_nghost-%COMP%]     .mat-form-field-infix{width:100%}  .mat-form-field{line-height:1.4em}"];
export { styles as styles };
